module.exports = __webpack_public_path__ + "img/grey-pin.c24d0534.png";